export default "__VITE_ASSET__C6R$xcR3__"